import styled from 'styled-components'
import { colors } from '../../theme'

/**
 * Estilos proprios da tela de Clientes.
 *
 * O botao e o painel do filtro de Segmento ficam aqui, e nao em LayoutTable, porque sao especificos
 * desta tela — LayoutTable e compartilhado por varias listagens e so deve guardar o que e generico.
 * As medidas acompanham SpanIcon/FilterStatus de LayoutTable, deslocadas para a direita para os dois
 * filtros conviverem lado a lado.
 */
export const SpanIconSegmento = styled.button`
  position: absolute;
  top: 16px;
  left: 347px;
  height: 42px;
  padding: 9px 14px;
  background-color: ${colors.grey100};
  border: none;
  cursor: pointer;
  border-radius: 9px;
  align-items: center;
  display: flex;
  gap: 8px;
  color: ${colors.grey900};
  font-size: 14px;
`

export const FilterSegmento = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-shadow: 0px 7px 20px rgba(0, 0, 0, 0.56);
  position: absolute;
  left: 347px;
  top: 68px;
  background-color: ${colors.surface};
  border-radius: 16px;
  padding: 10px;
  width: 320px;
  z-index: 10;
`
